module.exports = __webpack_public_path__ + "static/img/bg_zhezhao@2x.f192aed4.png";